module.exports = __webpack_public_path__ + "img/quiz_06.8c02b577.jpg";